/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    FORGOTTEN_PASSWORD: 'forgotten_password',
    STUDIO_REGISTRATION: 'studio_registration',
    STUDIO_REGISTRATION_JUST_NOTIFICATION: 'studio_registration_just_notification',
    STUDIO_LECTURE_CUSTOM_MESSAGE: 'studio_lecture_custom_message',
    STUDIO_WORKSHOP_CUSTOM_MESSAGE: 'studio_workshop_custom_message',
    TRIAL_EXPIRATION: 'trial_expiration', // in CRON
    PAYMENT_REGISTRATION: 'payment_registration', // in CRON
    PAYMENT_REMINDER: 'payment_reminder', // in CRON
    PAYMENT_ANNUAL_REMINDER: 'payment_annual_reminder', // in CRON
    PAYMENT_ANNUAL_REMINDER_DEPRECATED_TARIFF: 'payment_annual_reminder_deprecated_tariff', // in CRON
    PAYMENT_CONFIRMATION: 'payment_confirmation',
    CLIENT_CREDITS_EXPIRING_SOON: 'client_credits_expiring_soon', // in CRON
    CLIENT_PASS_EXPIRING_SOON: 'client_pass_expiring_soon', // in CRON
    CLIENT_ALTERNATE_ENTRIES_EXPIRING_SOON: 'client_alternate_entries_expiring_soon', // in CRON
    CLIENT_ALTERNATE_ENTRIES_EXPIRED: 'client_alternate_entries_expired', // in CRON
    CLIENT_PASS_EXPIRED: 'client_pass_expired', // in CRON
    CLIENT_CREDITS_EXPIRED: 'client_credits_expired', // in CRON
    DEACTIVATION_PLANNED: 'deactivation_planned',
    DEACTIVATION_REQUEST_COMPLETED: 'deactivation_request_completed',
    DEACTIVATION_FORCE_COMPLETED: 'deactivation_force_completed',
    DEACTIVATION_TRIAL_COMPLETED: 'deactivation_trial_completed', // in CRON
    CREDIT_BALANCE_ADDED: 'credit_balance_added',
    PASS_BALANCE_ADDED: 'pass_balance_added',
    LECTURER_ADDED: 'lecturer_added',
    LECTURER_LECTURE_REMINDER: 'lecturer_lecture_reminder', // in CRON
    CLIENT_REGISTRATION: 'client_registration',
    CLIENT_ASSIGNED_TO_STUDIO: 'client_assigned_to_studio',
    CLIENT_MIGRATED_TO_STUDIO: 'client_migrated_to_studio',
    CLIENT_LECTURE_REGISTRATION: 'client_lecture_registration',
    STUDIO_CLIENT_LECTURE_REGISTRATION: 'studio_client_lecture_registration',
    CLIENT_WORKSHOP_REGISTRATION: 'client_workshop_registration',
    CLIENT_COURSE_REGISTRATION: 'client_course_registration',
    STUDIO_CLIENT_WORKSHOP_REGISTRATION: 'studio_client_workshop_registration',
    STUDIO_CLIENT_COURSE_REGISTRATION: 'studio_client_course_registration',
    LECTURE_PAYMENT_CONFIRMATION: 'lecture_payment_confirmation',
    CREDIT_PAYMENT_CONFIRMATION: 'credit_payment_confirmation',
    PASS_PAYMENT_CONFIRMATION: 'pass_payment_confirmation',
    WORKSHOP_PAYMENT_CONFIRMATION: 'workshop_payment_confirmation',
    COURSE_PAYMENT_CONFIRMATION: 'course_payment_confirmation',
    LECTURE_CANCELLATION_FREE: 'lecture_cancellation_free',
    LECTURE_CANCELLATION_PENALTY: 'lecture_cancellation_penalty',
    LECTURE_CANCELLATION_INFO_FOR_STUDIO: 'lecture_cancellation_info_for_studio',
    LECTURE_RESERVATION_CANCELLED_BY_STUDIO: 'lecture_reservation_cancelled_by_studio',
    CLIENT_ORDER_CANCELLED_BY_STUDIO: 'client_order_cancelled_by_studio',
    LECTURE_CANCELLED: 'lecture_cancelled',
    COURSE_TERM_CANCELLED: 'course_term_cancelled',
    WORKSHOP_CANCELLED: 'workshop_cancelled',
    LECTURE_EDIT: 'lecture_edit',
    LECTURE_EDIT_FOR_LECTURER: 'lecture_edit_for_lecturer',
    COURSE_EDIT: 'course_edit',
    LECTURE_AUTO_RESERVATION_CREATED: 'lecture_auto_reservation_created',
    STUDIO_CREDIT_ORDER_CREATED: 'studio_credit_order_created',
    STUDIO_PASS_ORDER_CREATED: 'studio_pass_order_created',
    CREDIT_ORDER_CREATED: 'credit_order_created',
    PASS_ORDER_CREATED: 'pass_order_created',
    CLIENT_REGISTERED_TO_OFFICE: 'client_registered_to_office',
    LECTURE_RESERVATION_AVAILABLE: 'lecture_reservation_available',
    CLIENT_LECTURE_REMINDER: 'client_lecture_reminder', // in CRON
    LECTURER_ONLINE_LECTURE_REMINDER: 'lecturer_online_lecture_reminder', // in CRON
    STUDIO_CLIENT_CUSTOM_MESSAGE: 'studio_client_custom_message',
    CLIENT_ONLINE_INFO_UPDATE: 'client_online_info_update',
    LICENCE_ORDER: 'licence_order',
    LICENCE_ORDER_BY_CARD: 'licence_order_by_card',
    LICENCE_ORDER_FROM_BANK_ACCOUNT_TO_CARD: 'licence_order_from_bank_account_to_card',
    LICENCE_ORDER_SUBSCRIPTION_FAILED: 'licence_order_subscription_failed',
    COURSE_SESSION_RESERVATION_CANCELED_FOR_STUDIO: 'course_session_reservation_canceled_for_studio',
    COURSE_SESSION_RESERVATION_CANCELED: 'course_session_reservation_canceled',
    STUDIO_TARIFF_X_ORDERS_LEFT: 'studio_tariff_x_orders_left',
    STUDIO_TARIFF_ORDER_LIMIT_REACHED: 'studio_tariff_order_limit_reached',
    DEPRECATED_TARIFF_TURNED_OFF: 'deprecated_tariff_turned_off',
    VOUCHER_PAYMENT_CONFIRMATION: 'voucher_payment_confirmation',
    VOUCHER_ORDER_CREATED: 'voucher_order_created',
};
